export default {
    firstName: "",
    lastName: "",
    accountNumber: null,
    sortCode: null,
    paymentMethodId: null,
}
